// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleNoSapAccess} from '../../../shared/services/error-handlers';

const basePath = '/api';

export const getUser = async racfId => {

    const endPoint = `${basePath}/users/${racfId}`;
    const options = {
        endpointId: 'settings'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        // if this service returns an error it will redirect the user to the NO_SAP_ACCESS error page

        return handleNoSapAccess(response, racfId, 'USER');

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/get-user.js